import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import styled from "styled-components";
import { getUETDS, getUetdsExcel, getUetdsExcelSpecial } from "../../features/admin/adminSlice";
import Button from "../../components/shared/button/Btn";
import SingleInputFilter from "../../components/shared/SingleInputFilter";

import iller from "../../utils/iller";
import { gonderilmisOptions } from "../../utils/UETDSOptions";
import SingleInputSelect from "../../components/shared/SingleInputSelect";
import Pagination from "../../components/shared/Pagination";
import { useNavigate } from "react-router-dom";

import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
import UetdsContainer from "../../components/adminContainers/UetdsContainer";
import { showModal } from "../../features/modal/modalSlice";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;
    .content {
      gap: 60px;
      margin: 0 30px;
      margin-top: 20px;
      color: ${({ theme }) => theme.mainTextColor};
      @media (max-width: 1550px) {
        margin: 0;
        margin-top: 0;
        padding: 20px 30px 0px;
        overflow: auto;
      }
      .titles {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        padding-inline: 10px;
        font-size: var(--font-size-sm);
        font-weight: var(--font-weight-lg);

        .col{
          text-align: center !important;
          flex: 1;
          margin-right: 10px;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .col-sm{
          flex: .3;
        }

      }
      .btn-group {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: 20px;
      }

      .filter-container {
        width: 100%;
        height: auto;
        border-radius: 5px;
        display: flex;
        margin: 20px 0;
        flex-direction: column;
        gap: 20px;
        @media (max-width: 1550px) {
          flex-direction: column;
        }
        .button-container {
          display: flex;
          align-items: center;
          gap: 10px;
          margin-left: 10px;
          @media (max-width: 1550px) {
            margin-top: 15px;
          }
        }

        .filter-input-grp {
          margin: 0 2px;
          display: flex;
          gap: 20px;
          @media (max-width: 1550px) {
            align-items: center;
            justify-content: center;
            margin: 0 auto;
          }
        }
      }
    }
  }
`;

const UETDSYukBildirimi = () => {
  const { UETDSList, UETDSCount, statusCode, isLoadingExcel } = useSelector((state) => state.admin
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  //! filter state
  const [plaka, setPlaka] = useState("");
  const [TCNumara, setTCNumara] = useState("");

  const [yuklemeIli, setYuklemeIli] = useState("");
  const [bosaltmaIli, setBosaltmaIli] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const [isGonderilmis, setIsGonderilmis] = useState("Gönderilmemiş");

  const itemsPerPage = 10;

  const totalPages = Math.ceil(UETDSCount / itemsPerPage);
  const [filteredIller, setFilteredIller] = useState([]);

  useEffect(() => {
    const filtered = UETDSList?.map((item) => {
      return item.bosaltmaIlAdi;
    });
    setFilteredIller(
      iller.filter((item) => {
        return filtered?.includes(item.value);
      })
    );
  }, [yuklemeIli, UETDSList]);

  useEffect(() => {
    const query = {
      currentPage,
      yuklemeIlAdi: yuklemeIli,
      bosaltmaIlAdi: bosaltmaIli,
      plaka1: plaka,
      TCKimlikNo1: TCNumara,
      isEgeApproved: isGonderilmis === "Gönderilmemiş" ? false : true,
    };
    dispatch(getUETDS(query));
  }, [ currentPage, plaka, TCNumara, yuklemeIli, bosaltmaIli, isGonderilmis, UETDSList?.length, dispatch ]);

  useEffect(() => {
    if (statusCode === 200) {
      dispatch(getUETDS({currentPage: 1}));
    }
  }, [statusCode, dispatch]);

  // belirtilen sonunda liste tekrar dispatch edilir.
  useEffect(() => {
    const interval = setInterval(() => {
      const query = {
        currentPage,
        yuklemeIlAdi: yuklemeIli,
        bosaltmaIlAdi: bosaltmaIli,
        plaka1: plaka,
        TCKimlikNo1: TCNumara,
        isEgeApproved: isGonderilmis === "Gönderilmemiş" ? false : true,
      };
      dispatch(getUETDS(query));
    }, 300000); // 5 dakika = 300000 milisaniye

    return () => clearInterval(interval);
  }, [ currentPage, plaka, TCNumara, yuklemeIli, bosaltmaIli, isGonderilmis, UETDSList?.length, dispatch ]);

  //! gonderilmis page 1 den yüksekse gönderilmemişe cevirince boş cıkıyo (çünkü o kadar item olmuyo genelde)
  useEffect(() => {
    setCurrentPage(1);
  }, [isGonderilmis]);

  const titles = [
    "Üye Telefonu",
    "Üye Adı",
    "Sürücü TC No",
    "Plaka",
    "Sefer Başlangıcı",
    "Sefer Bitişi",
    "Nereden",
    "Nereye",
    "Yük Miktarı",
    "N/T",
    // "İşlem",
  ];

  const handleClear = () => {
    setCurrentPage(1);
    setPlaka("");
    setTCNumara("");
    setYuklemeIli("");
    setBosaltmaIli("");
    setIsGonderilmis("Gönderilmemiş");
  };

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"U-ETDS Yük Bildirimi"} position="sticky" />
        <div className="content">
          <div className="filter-container">
            <div className="filter-input-grp">
              <SingleInputFilter
                value={plaka}
                placeholder="Plaka"
                handleChange={setPlaka}
                width={"180px"}
              />
              <SingleInputFilter
                value={TCNumara}
                placeholder="Sürücü TC No"
                handleChange={setTCNumara}
                width={"180px"}
              />
              <SingleInputSelect
                value={isGonderilmis}
                handleChange={setIsGonderilmis}
                options={gonderilmisOptions}
                name={"isGonderilmis"}
                width={"180px"}
                placeholder="Seçiniz..."
              />
              <SingleInputSelect
                value={yuklemeIli}
                handleChange={setYuklemeIli}
                options={iller}
                name={"yuklemeIli"}
                width={"180px"}
                placeholder="Yükleme İli"
              />
              <SingleInputSelect
                value={bosaltmaIli}
                handleChange={setBosaltmaIli}
                options={iller}
                name={"bosaltmaIli"}
                width={"180px"}
                placeholder="Boşaltma İli"
              />
              <Button
                type="button"
                background={"#fff"}
                color={"#E85546"}
                handleClick={handleClear}
                padding="0 10px"
                width="160px"
              >Filtreleri Temizle</Button>
            </div>
            <div className="button-container">
              <Button
                type="button"
                background={"#fff"}
                color={"#E85546"}
                handleClick={() => dispatch(getUetdsExcel())}
                padding="0 10px"
                width="160px"
              >{
                  isLoadingExcel ? (
                    <SmallSpinner size="16px" color="#fff" bgColor="#E85446" />
                  ) : (
                    "Excel Çıktısı Al"
                  )
                }</Button>
                <Button
                type="button"
                background={"#fff"}
                color={"#E85546"}
                handleClick={() => dispatch(showModal("uetdsExcelSpecial"))}
                padding="0 10px"
                width="160px"
              >
                Excel Çıktısı Al 2
              </Button>
                
              <Button
                type="button"
                background={"#fff"}
                color={"#E85546"}
                // handleClick={() => navigate("/admin/u-etds-yuk-bildirimi-ekle")}
                handleClick={() => dispatch(showModal("createUETDS"))}
                padding="0 10px"
                width="160px"
              >Yük Bildirimi Ekle</Button>
            </div>
          </div>
          <div className="titles">
            {titles.map((item, i) => (
              <p className={(i === 8 || i === 9 || i === 10) ? "col col-sm" : "col"}>{item}</p>
            ))}
          </div>

          {UETDSList?.map((item)=>(
            <UetdsContainer isGonderilmis={isGonderilmis} data={item} />
          ))}
          {(UETDSList || UETDSList?.length > 0) && (
            <Pagination
              totalPages={totalPages}
              handleClick={setCurrentPage}
              currentPage={currentPage}
            />
          )}
        </div>
      </div>
    </Container>
  );
};

export default UETDSYukBildirimi;
